import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StatusStyles = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  left: 50%;\n  max-width: 21.25rem;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  width: 80%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.tiny;
});
var IconContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
    $type = _ref2.$type;
  return theme.colours.messaging[$type].main;
});
var StatusButtonWrapperStyles = styled('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing.medium;
});
var StatusWrapperStyles = styled('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  width: 100%;\n"])));

export { IconContainer, StatusButtonWrapperStyles, StatusStyles, StatusWrapperStyles };
//# sourceMappingURL=Status.styles.js.map
